import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import { Box } from '@livable/saas-react-components';
import { MembersTab } from './MembersTab';
import useStyles from './styles';
import { useNavigate } from 'react-router-dom';
import { MyTeamDashboard } from './MyTeamDashboard';
import { useStore } from 'src/stores';
export default function TeamSettingsPage() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  const store = useStore();
  const tabs = [{
    value: 'current',
    label: t('team_page.my_team')
  }, {
    value: 'former',
    label: t('team_page.former_team_members')
  }
  // {
  //   value: 'permission-settings',
  //   label: 'Permission settings',
  // },
  ];
  if (store.account.featureFlagsStore.getIsMultiAccountAccessEnabled) {
    tabs.splice(0, 1, {
      value: 'team-dashboard',
      label: t('team_page.my_team')
    });
  }
  const _useState = useState(store.account.featureFlagsStore.getIsMultiAccountAccessEnabled ? 'team-dashboard' : 'current'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleSelectedTabChange = (e, value) => {
    setSelectedTab(value);
  };
  useEffect(() => {
    if (localStorage.getItem('livable_demo_mode') === 'Demo') navigate('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    type: "navigation",
    position: "sticky",
    value: selectedTab,
    onChange: handleSelectedTabChange,
    "aria-label": "tabs navigation",
    className: classes.tabs
  }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    value: tab.value,
    label: tab.label,
    key: tab.value,
    'custom-attribute': '753-TeamSettingsPage-page-' + tab.value
  }))), /*#__PURE__*/React.createElement(Box, null, selectedTab === 'current' && /*#__PURE__*/React.createElement(MembersTab, null), selectedTab === 'former' && /*#__PURE__*/React.createElement(MembersTab, {
    former: true,
    hideActionsBar: true
  })), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && selectedTab === 'team-dashboard' && /*#__PURE__*/React.createElement(MyTeamDashboard, null));
}